export const translations: Record<'pl' | 'en' | 'de', Record<string, string>> = {
  pl: {
    // Common
    'common.save': 'Zapisz',
    'common.cancel': 'Anuluj',
    'common.delete': 'Usuń',
    'common.edit': 'Edytuj',
    'common.back': 'Wróć',
    'common.next': 'Dalej',
    'common.loading': 'Ładowanie...',
    'common.error': 'Błąd',
    'common.success': 'Sukces',
    'common.reset': 'Reset',
    'common.download': 'Pobierz',

    // App
    'app.title': 'YourModel.eu',

    // Header
    'header.credits': 'Kredyty',
    'header.logout': 'Wyloguj',
    'header.admin': 'Panel administratora',
    'header.language': 'Język',

    // Public Navigation
    'nav.product': 'Opis produktu',
    'nav.inspiration': 'Inspiracje',
    'nav.contact': 'Kontakt',
    'nav.login': 'Login',
    'nav.register': 'Rejestracja',

    // Home Page
    'home.tagline': 'Your clothes. Your models. YourModel.eu',
    'home.short': 'YourModel.eu tworzy realistyczne zdjęcia modelek — wirtualnych lub prawdziwych — prezentujących odzież i akcesoria marek modowych: buty, torebki, okulary i więcej.',
    'home.full.1': 'YourModel.eu to zaawansowana platforma AI dla branży modowej, łącząca świat wirtualny z rzeczywistym.',
    'home.full.2': 'Umożliwia markom modowym i sklepom internetowym generowanie profesjonalnych zdjęć modelek — zarówno wirtualnych, jak i prawdziwych — prezentujących rzeczywistą odzież oraz akcesoria: buty, torebki, okulary i inne dodatki.',
    'home.full.3': 'System pozwala w pełni kontrolować wygląd modelki, stylizację, tło i oświetlenie, co daje nieograniczone możliwości tworzenia contentu marketingowego bez konieczności organizowania kosztownych sesji zdjęciowych.',
    'home.full.4': 'Dzięki YourModel.eu marki mogą błyskawicznie produkować zdjęcia i kampanie, które wyglądają jak z profesjonalnego studia — dostępne w kilka minut, 24/7.',

    // Register
    'register.info': 'Rejestracja własnych kont będzie wkrótce dostępna. Na razie zaloguj się kontem testowym lub skontaktuj się z nami.',
    'register.repeatPassword': 'Powtórz hasło',
    'register.submit': 'Zarejestruj (wkrótce)',

    // Login
    'login.title': 'Witaj',
    'login.subtitle': 'Platforma do wirtualnego przymierzania odzieży',
    'login.signInPrompt': 'Zaloguj się, aby kontynuować',
    'login.username': 'Nazwa użytkownika',
    'login.password': 'Hasło',
    'login.remember': 'Zapamiętaj mnie',
    'login.forgot': 'Zapomniałeś hasła?',
    'login.submit': 'Zaloguj',
    'login.loggingIn': 'Logowanie...',
    'login.error.credentials': 'Nieprawidłowa nazwa użytkownika lub hasło',
    'login.error.required': 'Proszę podać nazwę użytkownika i hasło',
    'login.error.general': 'Wystąpił błąd podczas logowania',
    'login.error.google': 'Błąd logowania przez Google',
    'login.or': 'LUB',
    'login.googlePrivacy': 'Używamy Google tylko do bezpiecznego logowania. Nie mamy dostępu do Twoich danych osobowych.',

    // Mode Selection
    'mode.title': 'Wybór trybu pracy',
    'mode.selectTitle': 'Wybierz tryb pracy',
    'mode.selectSubtitle': 'Wybierz jeden z dostępnych trybów pracy z aplikacją',

    'mode.card.onModel.title': 'Zdjęcia odzieży na człowieku',
    'mode.card.onModel.description': 'Umożliwia przesyłanie własnych zdjęć i nakładanie na nie wirtualnych ubrań. Idealne do wizualizacji odzieży na Twoim zdjęciu lub zdjęciu modela.',
    'mode.card.onModel.cta': 'Rozpocznij tworzenie',

    'mode.card.flatLay.title': 'Zdjęcia odzieży na płasko',
    'mode.card.flatLay.description': 'Umożliwia wizualizację Twoich ubrań na profesjonalnych, wirtualnych modelach. Wybierz model, tło studyjne i zobacz jak będzie wyglądać Twoja kolekcja.',
    'mode.card.flatLay.cta': 'Rozpocznij tworzenie',

    'mode.card.easyWay.title': 'Foto Sesja',
    'mode.card.easyWay.description': 'Szybka generacja z wieloma modelami AI. Załaduj 1-4 obrazy (modelka, ubranie, akcesoria), wybierz model i wygeneruj!',
    'mode.card.easyWay.cta': 'Rozpocznij tworzenie',

    'mode.card.video.title': 'Video',
    'mode.card.video.description': 'Generuj profesjonalne animacje video z obrazów modelki. Wybierz pozę, dodaj opis i uzyskaj 5-10s video!',
    'mode.card.video.cta': 'Generuj Video',

    'mode.badge.bestQuality': 'Najwyższa jakość',
    'mode.badge.multiModel': 'Multi-Model AI',
    'mode.badge.imageToVideo': 'Image-to-Video',

    // Foto Sesja (Photo Session)
    'easyWay.title': 'Foto Sesja - Szybka generacja',
    'easyWay.subtitle': 'Załaduj 1-4 obrazy (modelka, ubranie, akcesoria), wybierz model AI i wygeneruj!',

    'easyWay.upload.title': 'Załaduj obrazy (1-4)',
    'easyWay.upload.subtitle': 'Możesz załadować od 1 do 4 obrazów. Wszystkie pola są opcjonalne.',
    'easyWay.upload.model': 'Modelka/Model',
    'easyWay.upload.modelDesc': 'Zdjęcie osoby',
    'easyWay.upload.garment': 'Ubranie',
    'easyWay.upload.garmentDesc': 'Zdjęcie odzieży',
    'easyWay.upload.accessory1': 'Torebka',
    'easyWay.upload.accessory1Desc': 'Akcesoria 1',
    'easyWay.upload.accessory2': 'Okulary',
    'easyWay.upload.accessory2Desc': 'Akcesoria 2',
    'easyWay.upload.selectFile': 'Wybierz plik',
    'easyWay.upload.dragDrop': 'lub przeciągnij i upuść',

    'easyWay.model.title': 'Wybierz model AI',
    'easyWay.model.strawberry': 'strawberry',
    'easyWay.model.strawberryDesc': 'Generuje obrazy z twarzy/całej postaci modelki, uwzględnia pozę, ubiera w sukienki/koszule/spodnie/kurtki, generuje buty/torebki/okulary. ~20s',
    'easyWay.model.kiwi': 'kiwi-r',
    'easyWay.model.kiwiDesc': 'Specjalizacja: bielizna. Edycja obrazu, 1-4 obrazy, ~20s',
    'easyWay.model.melon': 'melon',
    'easyWay.model.melonDesc': 'Bardzo szybki, 2 obrazy, ~8s',
    'easyWay.model.blueberry': 'blueberry',
    'easyWay.model.blueberryDesc': 'Edycja bielizny, wsparcie dla 4K, 1-4 obrazy, ~30s',

    'easyWay.resolution.title': 'Rozdzielczość',
    'easyWay.resolution.2k': '2K (2048x2048)',
    'easyWay.resolution.2kPortrait': '2K portret (1024x2048)',
    'easyWay.resolution.4k': '4K (4096x4096)',
    'easyWay.resolution.4kPortrait': '4K portret (2048x4096)',

    'easyWay.prompt.title': 'Prompt tekstowy',
    'easyWay.prompt.select': 'Wybierz prompt',
    'easyWay.prompt.custom': 'Lub wpisz własny',
    'easyWay.prompt.preset1': 'Dress the model',
    'easyWay.prompt.preset2': 'Dress the model, choose shoes to match the garment',
    'easyWay.prompt.preset3': 'Dress her in a dress. The dress should be below the knee. Choose shoes to go with the dress.',
    'easyWay.prompt.helper': 'Wybierz gotowy prompt lub wpisz własny',

    'easyWay.generate': 'Generuj obraz',
    'easyWay.generating': 'Generowanie...',
    'easyWay.reset': 'Reset',
    'easyWay.results': 'Wygenerowane obrazy',
    'easyWay.success': 'Wygenerowano {count} obrazów!',
    'easyWay.error': 'Błąd generacji',

    'easyWay.advanced.title': 'Advanced Tools',
    'easyWay.advanced.subtitle': 'Narzędzia poprawiające jakość wygenerowanych obrazów',
    'easyWay.advanced.upscale.title': 'Lepsza jakość',
    'easyWay.advanced.upscale.description': 'Jeśli chcesz poprawić rozdzielczość zdjęcia oraz szczegóły, przykładowo koronkę w bieliźnie',
    'easyWay.advanced.upscale.source': 'Źródło obrazu',
    'easyWay.advanced.upscale.sourceLastGenerated': 'Ostatnio wygenerowany obraz',
    'easyWay.advanced.upscale.sourceUpload': 'Wgraj własny obraz',
    'easyWay.advanced.upscale.selectFile': 'Wybierz plik',
    'easyWay.advanced.upscale.noImage': 'Brak wygenerowanego obrazu',
    'easyWay.advanced.upscale.noFile': 'Wybierz plik do przetworzenia',
    'easyWay.advanced.upscale.scale': 'Rozdzielczość',
    'easyWay.advanced.upscale.scale2x': 'x2 (dwukrotnie większa)',
    'easyWay.advanced.upscale.scale4x': 'x4 (czterokrotnie większa)',
    'easyWay.advanced.upscale.faceEnhance': 'Poprawa twarzy',
    'easyWay.advanced.upscale.apply': 'Zastosuj upscaling',
    'easyWay.advanced.upscale.processing': 'Przetwarzanie...',
    'easyWay.advanced.handFix.title': 'Poprawa dłoni',
    'easyWay.advanced.handFix.description': 'Czasami jesteś zadowolony z wygenerowanego zdjęcia jednak dłonie nie są idealne',
    'easyWay.advanced.handFix.model': 'Wybierz model',
    'easyWay.advanced.handFix.apply': 'Popraw dłonie',
    'easyWay.advanced.handFix.processing': 'Poprawianie...',
    'easyWay.advanced.makeReal.title': 'Niech modelka wygląda bardziej realnie',
    'easyWay.advanced.makeReal.description': 'Czasami skóra modelki na zdjęciu jest plastikowa, lub wymaga poprawek. Użyj tej opcji jeśli chcesz sprawić że model/modelka będzie bardziej wyglądać "ludzko". Opcja zadziała też w przypadku zdjęć bardzo złej jakości lub rozdzielczości.',
    'easyWay.advanced.makeReal.model': 'Wybierz model',
    'easyWay.advanced.makeReal.apply': 'Popraw realizm',
    'easyWay.advanced.makeReal.processing': 'Poprawianie...',
    'easyWay.advanced.success': 'Przetwarzanie zakończone!',
    'easyWay.advanced.error': 'Błąd przetwarzania',
    'easyWay.advanced.result': 'Wynik',
    'easyWay.advanced.comparison.instruction': 'Przeciągnij suwak aby porównać przed i po',
    'easyWay.advanced.comparison.before': 'Przed',
    'easyWay.advanced.comparison.after': 'Po',

    // Image Source Selector
    'easyWay.imageSource.title': 'Źródło obrazu',
    'easyWay.imageSource.lastGenerated': 'Ostatnio wygenerowany obraz',
    'easyWay.imageSource.upload': 'Wgraj własny obraz',
    'easyWay.imageSource.explorer': 'Przeglądaj dysk w chmurze',
    'easyWay.imageSource.selectFile': 'Wybierz plik',
    'easyWay.imageSource.openExplorer': 'Otwórz eksplorator',
    'easyWay.imageSource.selected': 'Wybrano',

    // Explorer
    'easyWay.explorer.title': 'Eksplorator plików',
    'easyWay.explorer.back': 'Wróć',
    'easyWay.explorer.newFolder': 'Nowy folder',
    'easyWay.explorer.folderName': 'Nazwa folderu',
    'easyWay.explorer.create': 'Utwórz',
    'easyWay.explorer.cancel': 'Anuluj',
    'easyWay.explorer.empty': 'Brak plików w tym folderze',
    'easyWay.explorer.close': 'Zamknij',
    'easyWay.explorer.selectImage': 'Wybierz obraz',
    'easyWay.explorer.confirmDelete': 'Czy na pewno chcesz usunąć {name}?',
    'easyWay.explorer.errorLoad': 'Błąd wczytywania plików',
    'easyWay.explorer.errorCreate': 'Błąd tworzenia folderu',
    'easyWay.explorer.errorDelete': 'Błąd usuwania',
    'easyWay.explorer.noPreview': 'Kliknij na obrazek aby zobaczyć podgląd',

    // Video
    'video.title': 'Video Generation',
    'video.subtitle': 'Upload an image, select a pose, and click "Generate Video" to create professional animations',

    'video.step1': 'Upload Model Image',
    'video.step1.hint': 'Upload a model image to get started',
    'video.step1.upload': 'Click to upload model image',

    'video.step2': 'Select Pose (Optional)',
    'video.step2.hint': 'Select a pose or enter a custom prompt below',

    'video.step3': 'Add Custom Description (Optional)',
    'video.step3.placeholder': 'Describe the desired video animation (e.g., \'wearing elegant evening dress, professional lighting\')',

    'video.advanced': 'Advanced Options',
    'video.generate': 'Generate Video',
    'video.generating': 'Generating Video...',
    'video.result': 'Generated Video',
    'video.download': 'Download Video',

    'video.error.noImage': 'Please select an image',
    'video.error.noPose': 'Please select a pose or enter a custom prompt',

    'video.status.uploading': 'Uploading image...',
    'video.status.starting': 'Starting video generation...',
    'video.status.progress': 'Video generation in progress (Job: {jobId})...',
    'video.status.completed': 'Video generation completed!',

    'video.ready.title': 'Ready!',
    'video.ready.message': 'Click the button below to start video generation',
    'video.upload.enable': 'Upload an image to enable generation',
    'video.pose.enable': 'Select a pose or enter a prompt to enable generation',

    // Project Selection
    'project.title': 'Wybierz projekt',
    'project.create': 'Utwórz nowy projekt',
    'project.select': 'Wybierz projekt',
    'project.delete': 'Usuń projekt',
    'project.confirmDelete': 'Czy na pewno chcesz usunąć ten projekt?',

    // Designer
    'designer.workflow': 'Workflow',
    'designer.parameters': 'Parametry',
    'designer.upload': 'Wgraj obrazy',
    'designer.generate': 'Generuj',

    // Admin
    'admin.title': 'Panel Administratora',
    'admin.subtitle': 'Zarządzanie użytkownikami, credits i ustawieniami systemu',
    'admin.comingSoon': 'Wkrótce dostępne',
    'admin.tabs.users': 'Użytkownicy',
    'admin.tabs.google': 'OAuth Google',
    'admin.tabs.stats': 'Statystyki',

    'admin.users.addUser': 'Dodaj użytkownika',
    'admin.users.search': 'Szukaj...',
    'admin.users.deleteConfirm': 'Czy na pewno chcesz usunąć użytkownika {username}?',
    'admin.users.deleteFailed': 'Nie udało się usunąć użytkownika',
    'admin.users.password': 'Hasło',
    'admin.users.newPassword': 'Nowe hasło',
    'admin.users.confirmPassword': 'Potwierdź hasło',
    'admin.users.currentCredits': 'Aktualny stan credits',
    'admin.users.creditsToAdd': 'Liczba credits do dodania',
    'admin.users.creditsHelp': 'Podaj liczbę credits do dodania do konta użytkownika',

    'admin.users.columns.username': 'Nazwa użytkownika',
    'admin.users.columns.email': 'Email',
    'admin.users.columns.role': 'Rola',
    'admin.users.columns.credits': 'Credits',
    'admin.users.columns.used': 'Użyto',
    'admin.users.columns.status': 'Status',
    'admin.users.columns.authMethod': 'Metoda auth',
    'admin.users.columns.actions': 'Akcje',

    'admin.users.actions.edit': 'Edytuj',
    'admin.users.actions.credits': 'Zarządzaj credits',
    'admin.users.actions.password': 'Zmień hasło',
    'admin.users.actions.delete': 'Usuń',

    'admin.users.validation.required': 'To pole jest wymagane',
    'admin.users.validation.invalidNumber': 'Podaj prawidłową liczbę',
    'admin.users.validation.passwordMismatch': 'Hasła nie są identyczne',
    'admin.users.validation.passwordTooShort': 'Hasło musi mieć minimum 8 znaków',

    'common.create': 'Utwórz',
    'common.assign': 'Przydziel',

    // Credits
    'credits.label': 'credits',
    'credits.lowWarning': 'Niski stan credits! Pozostało mniej niż 5.',
    'credits.unlimited': 'Nieograniczone',
    'credits.remaining': 'Pozostało',
    'credits.used': 'Użyto',

    // Errors
    'error.network': 'Błąd połączenia sieciowego',
    'error.upload': 'Błąd podczas uploadu',
    'error.generation': 'Błąd podczas generacji',
    'error.unknown': 'Wystąpił nieznany błąd',
  },
  en: {
    // Common
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.back': 'Back',
    'common.next': 'Next',
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.success': 'Success',
    'common.reset': 'Reset',
    'common.download': 'Download',

    // App
    'app.title': 'YourModel.eu',

    // Header
    'header.credits': 'Credits',
    'header.logout': 'Logout',
    'header.admin': 'Admin Panel',
    'header.language': 'Language',

    // Public Navigation
    'nav.product': 'Product',
    'nav.inspiration': 'Inspiration',
    'nav.contact': 'Contact',
    'nav.login': 'Login',
    'nav.register': 'Register',

    // Home Page
    'home.tagline': 'Your clothes. Your models. YourModel.eu',
    'home.short': 'YourModel.eu creates realistic images of virtual or real models showcasing your fashion products — from clothing to accessories like shoes, bags, and glasses.',
    'home.full.1': 'YourModel.eu is an advanced AI-powered platform for the fashion industry that seamlessly blends virtual and real modeling.',
    'home.full.2': 'It enables brands and e-commerce stores to create high-quality photos of models — virtual or real — wearing actual clothing and accessories such as shoes, handbags, and eyewear.',
    'home.full.3': 'The platform offers full creative control over model appearance, styling, background, and lighting, allowing brands to produce professional-grade marketing visuals without the time and cost of traditional photo shoots.',
    'home.full.4': 'With YourModel.eu, fashion brands can instantly generate studio-quality content and launch campaigns in minutes — any time, anywhere.',

    // Register
    'register.info': 'Self-service registration will be available soon. For now, log in with a test account or contact us.',
    'register.repeatPassword': 'Repeat password',
    'register.submit': 'Register (coming soon)',

    // Login
    'login.title': 'Welcome',
    'login.subtitle': 'Virtual clothing try-on platform',
    'login.signInPrompt': 'Sign in to continue',
    'login.username': 'Username',
    'login.password': 'Password',
    'login.remember': 'Remember me',
    'login.forgot': 'Forgot password?',
    'login.submit': 'Login',
    'login.loggingIn': 'Logging in...',
    'login.error.credentials': 'Invalid username or password',
    'login.error.required': 'Please enter username and password',
    'login.error.general': 'An error occurred during login',
    'login.error.google': 'Google login error',
    'login.or': 'OR',
    'login.googlePrivacy': 'We use Google only for secure login. We do not have access to your personal data.',

    // Mode Selection
    'mode.title': 'Work mode selection',
    'mode.selectTitle': 'Choose work mode',
    'mode.selectSubtitle': 'Choose one of the available work modes',

    'mode.card.onModel.title': 'Clothes on a human photo',
    'mode.card.onModel.description': 'Allows uploading your own photos and applying virtual clothing to them. Ideal for visualizing clothes on your photo or a model\'s photo.',
    'mode.card.onModel.cta': 'Start creating',

    'mode.card.flatLay.title': 'Clothes flat-lay photos',
    'mode.card.flatLay.description': 'Enables visualization of your clothes on professional, virtual models. Choose a model, studio background and see how your collection will look.',
    'mode.card.flatLay.cta': 'Start creating',

    'mode.card.easyWay.title': 'Photo Session',
    'mode.card.easyWay.description': 'Fast generation with multiple AI models. Upload 1-4 images (model, garment, accessories), choose a model and generate!',
    'mode.card.easyWay.cta': 'Start creating',

    'mode.card.video.title': 'Video',
    'mode.card.video.description': 'Generate professional video animations from model images. Select a pose, add description and get 5-10s video!',
    'mode.card.video.cta': 'Generate Video',

    'mode.badge.bestQuality': 'Best quality',
    'mode.badge.multiModel': 'Multi-Model AI',
    'mode.badge.imageToVideo': 'Image-to-Video',

    // Photo Session
    'easyWay.title': 'Photo Session - Fast generation',
    'easyWay.subtitle': 'Upload 1-4 images (model, garment, accessories), choose AI model and generate!',

    'easyWay.upload.title': 'Upload images (1-4)',
    'easyWay.upload.subtitle': 'You can upload from 1 to 4 images. All fields are optional.',
    'easyWay.upload.model': 'Model',
    'easyWay.upload.modelDesc': 'Person photo',
    'easyWay.upload.garment': 'Garment',
    'easyWay.upload.garmentDesc': 'Clothing photo',
    'easyWay.upload.accessory1': 'Bag',
    'easyWay.upload.accessory1Desc': 'Accessory 1',
    'easyWay.upload.accessory2': 'Glasses',
    'easyWay.upload.accessory2Desc': 'Accessory 2',
    'easyWay.upload.selectFile': 'Select file',
    'easyWay.upload.dragDrop': 'or drag and drop',

    'easyWay.model.title': 'Select AI model',
    'easyWay.model.strawberry': 'strawberry',
    'easyWay.model.strawberryDesc': 'Generates images from face/full body, includes pose, dresses model in dresses/shirts/pants/jackets, generates shoes/bags/glasses. ~20s',
    'easyWay.model.kiwi': 'kiwi-r',
    'easyWay.model.kiwiDesc': 'Specialization: lingerie. Image editing, 1-4 images, ~20s',
    'easyWay.model.melon': 'melon',
    'easyWay.model.melonDesc': 'Very fast, 2 images, ~8s',
    'easyWay.model.blueberry': 'blueberry',
    'easyWay.model.blueberryDesc': 'Lingerie editing, 4K support, 1-4 images, ~30s',

    'easyWay.resolution.title': 'Resolution',
    'easyWay.resolution.2k': '2K (2048x2048)',
    'easyWay.resolution.2kPortrait': '2K portrait (1024x2048)',
    'easyWay.resolution.4k': '4K (4096x4096)',
    'easyWay.resolution.4kPortrait': '4K portrait (2048x4096)',

    'easyWay.prompt.title': 'Text prompt',
    'easyWay.prompt.select': 'Select prompt',
    'easyWay.prompt.custom': 'Or enter custom',
    'easyWay.prompt.preset1': 'Dress the model',
    'easyWay.prompt.preset2': 'Dress the model, choose shoes to match the garment',
    'easyWay.prompt.preset3': 'Dress her in a dress. The dress should be below the knee. Choose shoes to go with the dress.',
    'easyWay.prompt.helper': 'Select a preset prompt or enter your own',

    'easyWay.generate': 'Generate image',
    'easyWay.generating': 'Generating...',
    'easyWay.reset': 'Reset',
    'easyWay.results': 'Generated images',
    'easyWay.success': 'Generated {count} images!',
    'easyWay.error': 'Generation error',

    'easyWay.advanced.title': 'Advanced Tools',
    'easyWay.advanced.subtitle': 'Tools for improving quality of generated images',
    'easyWay.advanced.upscale.title': 'Better Quality',
    'easyWay.advanced.upscale.description': 'If you want to improve image resolution and details, for example lace in lingerie',
    'easyWay.advanced.upscale.source': 'Image source',
    'easyWay.advanced.upscale.sourceLastGenerated': 'Last generated image',
    'easyWay.advanced.upscale.sourceUpload': 'Upload your own image',
    'easyWay.advanced.upscale.selectFile': 'Select file',
    'easyWay.advanced.upscale.noImage': 'No generated image',
    'easyWay.advanced.upscale.noFile': 'Select file to process',
    'easyWay.advanced.upscale.scale': 'Resolution',
    'easyWay.advanced.upscale.scale2x': 'x2 (double size)',
    'easyWay.advanced.upscale.scale4x': 'x4 (quadruple size)',
    'easyWay.advanced.upscale.faceEnhance': 'Face enhancement',
    'easyWay.advanced.upscale.apply': 'Apply upscaling',
    'easyWay.advanced.upscale.processing': 'Processing...',
    'easyWay.advanced.handFix.title': 'Hand Fix',
    'easyWay.advanced.handFix.description': 'Sometimes you are satisfied with generated photo but hands are not perfect',
    'easyWay.advanced.handFix.model': 'Select model',
    'easyWay.advanced.handFix.apply': 'Fix hands',
    'easyWay.advanced.handFix.processing': 'Fixing...',
    'easyWay.advanced.makeReal.title': 'Make the Model Look More Real',
    'easyWay.advanced.makeReal.description': 'Sometimes the model\'s skin in the photo looks plastic or needs improvement. Use this option if you want to make the model look more "human". This option also works for very low quality or low resolution images.',
    'easyWay.advanced.makeReal.model': 'Select model',
    'easyWay.advanced.makeReal.apply': 'Improve realism',
    'easyWay.advanced.makeReal.processing': 'Processing...',
    'easyWay.advanced.success': 'Processing completed!',
    'easyWay.advanced.error': 'Processing error',
    'easyWay.advanced.result': 'Result',
    'easyWay.advanced.comparison.instruction': 'Drag the slider to compare before and after',
    'easyWay.advanced.comparison.before': 'Before',
    'easyWay.advanced.comparison.after': 'After',

    // Image Source Selector
    'easyWay.imageSource.title': 'Image Source',
    'easyWay.imageSource.lastGenerated': 'Last generated image',
    'easyWay.imageSource.upload': 'Upload your own image',
    'easyWay.imageSource.explorer': 'Browse cloud storage',
    'easyWay.imageSource.selectFile': 'Select file',
    'easyWay.imageSource.openExplorer': 'Open explorer',
    'easyWay.imageSource.selected': 'Selected',

    // Explorer
    'easyWay.explorer.title': 'File Explorer',
    'easyWay.explorer.back': 'Back',
    'easyWay.explorer.newFolder': 'New folder',
    'easyWay.explorer.folderName': 'Folder name',
    'easyWay.explorer.create': 'Create',
    'easyWay.explorer.cancel': 'Cancel',
    'easyWay.explorer.empty': 'No files in this folder',
    'easyWay.explorer.close': 'Close',
    'easyWay.explorer.selectImage': 'Select image',
    'easyWay.explorer.confirmDelete': 'Are you sure you want to delete {name}?',
    'easyWay.explorer.errorLoad': 'Error loading files',
    'easyWay.explorer.errorCreate': 'Error creating folder',
    'easyWay.explorer.errorDelete': 'Error deleting',
    'easyWay.explorer.noPreview': 'Click on an image to see preview',

    // Video
    'video.title': 'Video Generation',
    'video.subtitle': 'Upload an image, select a pose, and click "Generate Video" to create professional animations',

    'video.step1': 'Upload Model Image',
    'video.step1.hint': 'Upload a model image to get started',
    'video.step1.upload': 'Click to upload model image',

    'video.step2': 'Select Pose (Optional)',
    'video.step2.hint': 'Select a pose or enter a custom prompt below',

    'video.step3': 'Add Custom Description (Optional)',
    'video.step3.placeholder': 'Describe the desired video animation (e.g., \'wearing elegant evening dress, professional lighting\')',

    'video.advanced': 'Advanced Options',
    'video.generate': 'Generate Video',
    'video.generating': 'Generating Video...',
    'video.result': 'Generated Video',
    'video.download': 'Download Video',

    'video.error.noImage': 'Please select an image',
    'video.error.noPose': 'Please select a pose or enter a custom prompt',

    'video.status.uploading': 'Uploading image...',
    'video.status.starting': 'Starting video generation...',
    'video.status.progress': 'Video generation in progress (Job: {jobId})...',
    'video.status.completed': 'Video generation completed!',

    'video.ready.title': 'Ready!',
    'video.ready.message': 'Click the button below to start video generation',
    'video.upload.enable': 'Upload an image to enable generation',
    'video.pose.enable': 'Select a pose or enter a prompt to enable generation',

    // Project Selection
    'project.title': 'Select project',
    'project.create': 'Create new project',
    'project.select': 'Select project',
    'project.delete': 'Delete project',
    'project.confirmDelete': 'Are you sure you want to delete this project?',

    // Designer
    'designer.workflow': 'Workflow',
    'designer.parameters': 'Parameters',
    'designer.upload': 'Upload images',
    'designer.generate': 'Generate',

    // Admin
    'admin.title': 'Admin Panel',
    'admin.subtitle': 'Manage users, credits and system settings',
    'admin.comingSoon': 'Coming soon',
    'admin.tabs.users': 'Users',
    'admin.tabs.google': 'Google OAuth',
    'admin.tabs.stats': 'Statistics',

    'admin.users.addUser': 'Add User',
    'admin.users.search': 'Search...',
    'admin.users.deleteConfirm': 'Are you sure you want to delete user {username}?',
    'admin.users.deleteFailed': 'Failed to delete user',
    'admin.users.password': 'Password',
    'admin.users.newPassword': 'New password',
    'admin.users.confirmPassword': 'Confirm password',
    'admin.users.currentCredits': 'Current credits balance',
    'admin.users.creditsToAdd': 'Number of credits to add',
    'admin.users.creditsHelp': 'Enter the number of credits to add to the user account',

    'admin.users.columns.username': 'Username',
    'admin.users.columns.email': 'Email',
    'admin.users.columns.role': 'Role',
    'admin.users.columns.credits': 'Credits',
    'admin.users.columns.used': 'Used',
    'admin.users.columns.status': 'Status',
    'admin.users.columns.authMethod': 'Auth Method',
    'admin.users.columns.actions': 'Actions',

    'admin.users.actions.edit': 'Edit',
    'admin.users.actions.credits': 'Manage Credits',
    'admin.users.actions.password': 'Change Password',
    'admin.users.actions.delete': 'Delete',

    'admin.users.validation.required': 'This field is required',
    'admin.users.validation.invalidNumber': 'Enter a valid number',
    'admin.users.validation.passwordMismatch': 'Passwords do not match',
    'admin.users.validation.passwordTooShort': 'Password must be at least 8 characters',

    'common.create': 'Create',
    'common.assign': 'Assign',

    // Credits
    'credits.label': 'credits',
    'credits.lowWarning': 'Low credits! Less than 5 remaining.',
    'credits.unlimited': 'Unlimited',
    'credits.remaining': 'Remaining',
    'credits.used': 'Used',

    // Errors
    'error.network': 'Network connection error',
    'error.upload': 'Upload error',
    'error.generation': 'Generation error',
    'error.unknown': 'An unknown error occurred',
  },
  de: {
    // Common
    'common.save': 'Speichern',
    'common.cancel': 'Abbrechen',
    'common.delete': 'Löschen',
    'common.edit': 'Bearbeiten',
    'common.back': 'Zurück',
    'common.next': 'Weiter',
    'common.loading': 'Wird geladen...',
    'common.error': 'Fehler',
    'common.success': 'Erfolg',
    'common.reset': 'Zurücksetzen',
    'common.download': 'Herunterladen',

    // App
    'app.title': 'YourModel.eu',

    // Header
    'header.credits': 'Guthaben',
    'header.logout': 'Abmelden',
    'header.admin': 'Admin-Panel',
    'header.language': 'Sprache',

    // Public Navigation
    'nav.product': 'Produkt',
    'nav.inspiration': 'Inspirationen',
    'nav.contact': 'Kontakt',
    'nav.login': 'Anmelden',
    'nav.register': 'Registrieren',

    // Home Page
    'home.tagline': 'Your clothes. Your models. YourModel.eu',
    'home.short': 'KI-Plattform für realistische Model-Fotos (Kleidung & Accessoires).',
    'home.full.1': 'YourModel.eu ist eine fortschrittliche KI-Plattform für die Modebranche, die die virtuelle und reale Welt verbindet.',
    'home.full.2': 'Sie ermöglicht Modemarken und Online-Shops die Erstellung professioneller Fotos von Models — sowohl virtuell als auch real — die echte Kleidung und Accessoires präsentieren: Schuhe, Taschen, Brillen und andere Artikel.',
    'home.full.3': 'Das System ermöglicht die vollständige Kontrolle über das Aussehen des Models, das Styling, den Hintergrund und die Beleuchtung und bietet unbegrenzte Möglichkeiten zur Erstellung von Marketing-Inhalten ohne die Organisation kostspieliger Fotoshootings.',
    'home.full.4': 'Mit YourModel.eu können Marken sofort Fotos und Kampagnen produzieren, die wie aus einem professionellen Studio aussehen — verfügbar in wenigen Minuten, 24/7.',

    // Login
    'login.title': 'Willkommen',
    'login.subtitle': 'Virtuelle Kleidungsanprobe-Plattform',
    'login.signInPrompt': 'Melden Sie sich an, um fortzufahren',
    'login.username': 'Benutzername',
    'login.password': 'Passwort',
    'login.remember': 'Angemeldet bleiben',
    'login.forgot': 'Passwort vergessen?',
    'login.submit': 'Anmelden',
    'login.loggingIn': 'Anmeldung läuft...',
    'login.error.credentials': 'Ungültiger Benutzername oder Passwort',
    'login.error.required': 'Bitte geben Sie Benutzername und Passwort ein',
    'login.error.general': 'Bei der Anmeldung ist ein Fehler aufgetreten',
    'login.error.google': 'Google-Anmeldung fehlgeschlagen',
    'login.or': 'ODER',
    'login.googlePrivacy': 'Wir verwenden Google nur für eine sichere Anmeldung. Wir haben keinen Zugriff auf Ihre persönlichen Daten.',

    // Mode Selection
    'mode.title': 'Arbeitsmodusauswahl',
    'mode.selectTitle': 'Arbeitsmodus wählen',
    'mode.selectSubtitle': 'Wählen Sie einen der verfügbaren Arbeitsmodi',

    'mode.card.onModel.title': 'Kleidung auf menschlichem Foto',
    'mode.card.onModel.description': 'Ermöglicht das Hochladen eigener Fotos und das Anwenden virtueller Kleidung. Ideal zur Visualisierung von Kleidung auf Ihrem Foto oder dem Foto eines Models.',
    'mode.card.onModel.cta': 'Erstellen beginnen',

    'mode.card.flatLay.title': 'Flach liegende Kleidungsfotos',
    'mode.card.flatLay.description': 'Ermöglicht die Visualisierung Ihrer Kleidung auf professionellen, virtuellen Models. Wählen Sie ein Model, einen Studio-Hintergrund und sehen Sie, wie Ihre Kollektion aussehen wird.',
    'mode.card.flatLay.cta': 'Erstellen beginnen',

    'mode.card.easyWay.title': 'Foto Session',
    'mode.card.easyWay.description': 'Schnelle Generierung mit mehreren KI-Modellen. Laden Sie 1-4 Bilder hoch (Model, Kleidungsstück, Accessoires), wählen Sie ein Modell und generieren Sie!',
    'mode.card.easyWay.cta': 'Erstellen beginnen',

    'mode.card.video.title': 'Video',
    'mode.card.video.description': 'Generieren Sie professionelle Videoanimationen aus Model-Bildern. Wählen Sie eine Pose, fügen Sie eine Beschreibung hinzu und erhalten Sie ein 5-10s Video!',
    'mode.card.video.cta': 'Video generieren',

    'mode.badge.bestQuality': 'Beste Qualität',
    'mode.badge.multiModel': 'Multi-Modell-KI',
    'mode.badge.imageToVideo': 'Bild-zu-Video',

    // Foto Session
    'easyWay.title': 'Foto Session - Schnelle Generierung',
    'easyWay.subtitle': 'Laden Sie 1-4 Bilder hoch (Model, Kleidungsstück, Accessoires), wählen Sie ein KI-Modell und generieren Sie!',

    'easyWay.upload.title': 'Bilder hochladen (1-4)',
    'easyWay.upload.subtitle': 'Sie können 1 bis 4 Bilder hochladen. Alle Felder sind optional.',
    'easyWay.upload.model': 'Model',
    'easyWay.upload.modelDesc': 'Personenfoto',
    'easyWay.upload.garment': 'Kleidungsstück',
    'easyWay.upload.garmentDesc': 'Kleidungsfoto',
    'easyWay.upload.accessory1': 'Tasche',
    'easyWay.upload.accessory1Desc': 'Accessoire 1',
    'easyWay.upload.accessory2': 'Brille',
    'easyWay.upload.accessory2Desc': 'Accessoire 2',
    'easyWay.upload.selectFile': 'Datei auswählen',
    'easyWay.upload.dragDrop': 'oder per Drag & Drop',

    'easyWay.model.title': 'KI-Modell auswählen',
    'easyWay.model.strawberry': 'strawberry',
    'easyWay.model.strawberryDesc': 'Generiert Bilder aus Gesicht/ganzem Körper, berücksichtigt Pose, kleidet Model in Kleider/Hemden/Hosen/Jacken, generiert Schuhe/Taschen/Brillen. ~20s',
    'easyWay.model.kiwi': 'kiwi-r',
    'easyWay.model.kiwiDesc': 'Spezialisierung: Unterwäsche. Bildbearbeitung, 1-4 Bilder, ~20s',
    'easyWay.model.melon': 'melon',
    'easyWay.model.melonDesc': 'Sehr schnell, 2 Bilder, ~8s',
    'easyWay.model.blueberry': 'blueberry',
    'easyWay.model.blueberryDesc': 'Unterwäsche-Bearbeitung, 4K-Unterstützung, 1-4 Bilder, ~30s',

    'easyWay.resolution.title': 'Auflösung',
    'easyWay.resolution.2k': '2K (2048x2048)',
    'easyWay.resolution.2kPortrait': '2K Hochformat (1024x2048)',
    'easyWay.resolution.4k': '4K (4096x4096)',
    'easyWay.resolution.4kPortrait': '4K Hochformat (2048x4096)',

    'easyWay.prompt.title': 'Text-Prompt',
    'easyWay.prompt.select': 'Prompt auswählen',
    'easyWay.prompt.custom': 'Oder eigenen eingeben',
    'easyWay.prompt.preset1': 'Dress the model',
    'easyWay.prompt.preset2': 'Dress the model, choose shoes to match the garment',
    'easyWay.prompt.preset3': 'Dress her in a dress. The dress should be below the knee. Choose shoes to go with the dress.',
    'easyWay.prompt.helper': 'Wählen Sie einen voreingestellten Prompt oder geben Sie einen eigenen ein',

    'easyWay.generate': 'Bild generieren',
    'easyWay.generating': 'Wird generiert...',
    'easyWay.reset': 'Zurücksetzen',
    'easyWay.results': 'Generierte Bilder',
    'easyWay.success': '{count} Bilder generiert!',
    'easyWay.error': 'Generierungsfehler',

    'easyWay.advanced.title': 'Erweiterte Tools',
    'easyWay.advanced.subtitle': 'Werkzeuge zur Verbesserung der Qualität generierter Bilder',
    'easyWay.advanced.upscale.title': 'Bessere Qualität',
    'easyWay.advanced.upscale.description': 'Wenn Sie die Bildauflösung und Details verbessern möchten, z.B. Spitze in Unterwäsche',
    'easyWay.advanced.upscale.source': 'Bildquelle',
    'easyWay.advanced.upscale.sourceLastGenerated': 'Zuletzt generiertes Bild',
    'easyWay.advanced.upscale.sourceUpload': 'Eigenes Bild hochladen',
    'easyWay.advanced.upscale.selectFile': 'Datei auswählen',
    'easyWay.advanced.upscale.noImage': 'Kein generiertes Bild',
    'easyWay.advanced.upscale.noFile': 'Datei zum Verarbeiten auswählen',
    'easyWay.advanced.upscale.scale': 'Auflösung',
    'easyWay.advanced.upscale.scale2x': 'x2 (doppelte Größe)',
    'easyWay.advanced.upscale.scale4x': 'x4 (vierfache Größe)',
    'easyWay.advanced.upscale.faceEnhance': 'Gesichtsverbesserung',
    'easyWay.advanced.upscale.apply': 'Upscaling anwenden',
    'easyWay.advanced.upscale.processing': 'Verarbeitung...',
    'easyWay.advanced.handFix.title': 'Hand-Korrektur',
    'easyWay.advanced.handFix.description': 'Manchmal sind Sie mit dem generierten Foto zufrieden, aber die Hände sind nicht perfekt',
    'easyWay.advanced.handFix.model': 'Modell auswählen',
    'easyWay.advanced.handFix.apply': 'Hände korrigieren',
    'easyWay.advanced.handFix.processing': 'Korrektur läuft...',
    'easyWay.advanced.makeReal.title': 'Lassen Sie das Model realistischer aussehen',
    'easyWay.advanced.makeReal.description': 'Manchmal sieht die Haut des Models auf dem Foto plastisch aus oder benötigt Verbesserungen. Verwenden Sie diese Option, wenn Sie möchten, dass das Model "menschlicher" aussieht. Diese Option funktioniert auch bei Fotos mit sehr geringer Qualität oder Auflösung.',
    'easyWay.advanced.makeReal.model': 'Modell auswählen',
    'easyWay.advanced.makeReal.apply': 'Realismus verbessern',
    'easyWay.advanced.makeReal.processing': 'Verarbeitung läuft...',
    'easyWay.advanced.success': 'Verarbeitung abgeschlossen!',
    'easyWay.advanced.error': 'Verarbeitungsfehler',
    'easyWay.advanced.result': 'Ergebnis',
    'easyWay.advanced.comparison.instruction': 'Ziehen Sie den Schieberegler, um vorher und nachher zu vergleichen',
    'easyWay.advanced.comparison.before': 'Vorher',
    'easyWay.advanced.comparison.after': 'Nachher',

    // Image Source Selector
    'easyWay.imageSource.title': 'Bildquelle',
    'easyWay.imageSource.lastGenerated': 'Zuletzt generiertes Bild',
    'easyWay.imageSource.upload': 'Eigenes Bild hochladen',
    'easyWay.imageSource.explorer': 'Cloud-Speicher durchsuchen',
    'easyWay.imageSource.selectFile': 'Datei auswählen',
    'easyWay.imageSource.openExplorer': 'Explorer öffnen',
    'easyWay.imageSource.selected': 'Ausgewählt',

    // Explorer
    'easyWay.explorer.title': 'Datei-Explorer',
    'easyWay.explorer.back': 'Zurück',
    'easyWay.explorer.newFolder': 'Neuer Ordner',
    'easyWay.explorer.folderName': 'Ordnername',
    'easyWay.explorer.create': 'Erstellen',
    'easyWay.explorer.cancel': 'Abbrechen',
    'easyWay.explorer.empty': 'Keine Dateien in diesem Ordner',
    'easyWay.explorer.close': 'Schließen',
    'easyWay.explorer.selectImage': 'Bild auswählen',
    'easyWay.explorer.confirmDelete': 'Möchten Sie {name} wirklich löschen?',
    'easyWay.explorer.errorLoad': 'Fehler beim Laden der Dateien',
    'easyWay.explorer.errorCreate': 'Fehler beim Erstellen des Ordners',
    'easyWay.explorer.errorDelete': 'Fehler beim Löschen',
    'easyWay.explorer.noPreview': 'Klicken Sie auf ein Bild, um eine Vorschau zu sehen',

    // Video
    'video.title': 'Video-Generierung',
    'video.subtitle': 'Laden Sie ein Bild hoch, wählen Sie eine Pose und klicken Sie auf "Video generieren", um professionelle Animationen zu erstellen',

    'video.step1': 'Model-Bild hochladen',
    'video.step1.hint': 'Laden Sie ein Model-Bild hoch, um zu beginnen',
    'video.step1.upload': 'Klicken Sie, um Model-Bild hochzuladen',

    'video.step2': 'Pose auswählen (Optional)',
    'video.step2.hint': 'Wählen Sie eine Pose oder geben Sie unten einen benutzerdefinierten Prompt ein',

    'video.step3': 'Benutzerdefinierte Beschreibung hinzufügen (Optional)',
    'video.step3.placeholder': 'Beschreiben Sie die gewünschte Videoanimation (z.B. "trägt elegantes Abendkleid, professionelle Beleuchtung")',

    'video.advanced': 'Erweiterte Optionen',
    'video.generate': 'Video generieren',
    'video.generating': 'Video wird generiert...',
    'video.result': 'Generiertes Video',
    'video.download': 'Video herunterladen',

    'video.error.noImage': 'Bitte wählen Sie ein Bild aus',
    'video.error.noPose': 'Bitte wählen Sie eine Pose oder geben Sie einen benutzerdefinierten Prompt ein',

    'video.status.uploading': 'Bild wird hochgeladen...',
    'video.status.starting': 'Video-Generierung wird gestartet...',
    'video.status.progress': 'Video-Generierung läuft (Job: {jobId})...',
    'video.status.completed': 'Video-Generierung abgeschlossen!',

    'video.ready.title': 'Bereit!',
    'video.ready.message': 'Klicken Sie auf die Schaltfläche unten, um die Video-Generierung zu starten',
    'video.upload.enable': 'Laden Sie ein Bild hoch, um die Generierung zu aktivieren',
    'video.pose.enable': 'Wählen Sie eine Pose oder geben Sie einen Prompt ein, um die Generierung zu aktivieren',

    // Project Selection
    'project.title': 'Projekt auswählen',
    'project.create': 'Neues Projekt erstellen',
    'project.select': 'Projekt auswählen',
    'project.delete': 'Projekt löschen',
    'project.confirmDelete': 'Sind Sie sicher, dass Sie dieses Projekt löschen möchten?',

    // Designer
    'designer.workflow': 'Workflow',
    'designer.parameters': 'Parameter',
    'designer.upload': 'Bilder hochladen',
    'designer.generate': 'Generieren',

    // Admin
    'admin.title': 'Admin-Panel',
    'admin.subtitle': 'Verwalten Sie Benutzer, Guthaben und Systemeinstellungen',
    'admin.comingSoon': 'Demnächst verfügbar',
    'admin.tabs.users': 'Benutzer',
    'admin.tabs.google': 'Google OAuth',
    'admin.tabs.stats': 'Statistiken',

    'admin.users.addUser': 'Benutzer hinzufügen',
    'admin.users.search': 'Suchen...',
    'admin.users.deleteConfirm': 'Möchten Sie den Benutzer {username} wirklich löschen?',
    'admin.users.deleteFailed': 'Benutzer konnte nicht gelöscht werden',
    'admin.users.password': 'Passwort',
    'admin.users.newPassword': 'Neues Passwort',
    'admin.users.confirmPassword': 'Passwort bestätigen',
    'admin.users.currentCredits': 'Aktuelles Guthaben',
    'admin.users.creditsToAdd': 'Anzahl der hinzuzufügenden Guthaben',
    'admin.users.creditsHelp': 'Geben Sie die Anzahl der Guthaben ein, die dem Benutzerkonto hinzugefügt werden sollen',

    'admin.users.columns.username': 'Benutzername',
    'admin.users.columns.email': 'E-Mail',
    'admin.users.columns.role': 'Rolle',
    'admin.users.columns.credits': 'Guthaben',
    'admin.users.columns.used': 'Verwendet',
    'admin.users.columns.status': 'Status',
    'admin.users.columns.authMethod': 'Auth-Methode',
    'admin.users.columns.actions': 'Aktionen',

    'admin.users.actions.edit': 'Bearbeiten',
    'admin.users.actions.credits': 'Guthaben verwalten',
    'admin.users.actions.password': 'Passwort ändern',
    'admin.users.actions.delete': 'Löschen',

    'admin.users.validation.required': 'Dieses Feld ist erforderlich',
    'admin.users.validation.invalidNumber': 'Geben Sie eine gültige Zahl ein',
    'admin.users.validation.passwordMismatch': 'Passwörter stimmen nicht überein',
    'admin.users.validation.passwordTooShort': 'Passwort muss mindestens 8 Zeichen lang sein',

    'common.create': 'Erstellen',
    'common.assign': 'Zuweisen',

    // Credits
    'credits.label': 'Guthaben',
    'credits.lowWarning': 'Niedriges Guthaben! Weniger als 5 übrig.',
    'credits.unlimited': 'Unbegrenzt',
    'credits.remaining': 'Verbleibend',
    'credits.used': 'Verwendet',

    // Errors
    'error.network': 'Netzwerkverbindungsfehler',
    'error.upload': 'Upload-Fehler',
    'error.generation': 'Generierungsfehler',
    'error.unknown': 'Ein unbekannter Fehler ist aufgetreten',
  }
}
